/* eslint-disable */
import Swiper, {Navigation} from 'swiper';


export default {
	init() {
		// JavaScript to be fired on the home page
	},
	finalize() {

		var swiperVariantes = new Swiper('.variantes-container', {
			modules: [Navigation],
			direction: 'horizontal',
			loop: false,
			slidesPerView: 4,
			spaceBetween: 16,
			threshold: 20,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				320: {
					slidesPerView: 1,
				},
				550: {
					slidesPerView: 2,
				},
				800: {
					slidesPerView: 3,
				},
				1100: {
					slidesPerView: 4,
				}
			}
		})

		if (swiperVariantes.length) {
			swiperVariantes.slides.on('click', function () {
				swiperVariantes.slideTo(swiperVariantes.clickedIndex);
			});
		}

		$('.dimensions').not('.slick-initialized').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			infinite: true,
			variableWidth: true,
			centerMode: false,
			speed: 300,
			cssEase: 'ease',
			prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-disabled="false" style="display: inline;"><g transform="translate(0 24) rotate(-90)"><rect width="24" height="24" fill="#14181e" opacity="0"></rect><g transform="translate(5 8)"><path d="M7,0a1,1,0,0,0-.707.293l-6,6A1,1,0,0,0,1.707,7.707L7,2.414l5.293,5.293a1,1,0,1,0,1.414-1.414l-6-6A1,1,0,0,0,7,0Z" fill="#14181e"></path></g></g></svg>',
			nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-disabled="false" style="display: inline;"><g transform="translate(0 24) rotate(-90)"><rect width="24" height="24" fill="#14181e" opacity="0"></rect><g transform="translate(5 8)"><path d="M12,16a1,1,0,0,1-.707-.293l-6-6A1,1,0,1,1,6.707,8.293L12,13.586l5.293-5.293a1,1,0,0,1,1.414,1.414l-6,6A1,1,0,0,1,12,16Z" transform="translate(-5 -8)" fill="#14181e"></path></g></g></svg>',
			touchThreshold: 100,
			responsive: [
				{
					breakpoint: 1520,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						centerMode: true,
					},
				}],
		})


		$('.nav-item.nav-link').on('click', function () {
			$('.coloris').not('.slick-initialized').slick('unslick');
			setTimeout(function () {
				$('.coloris').not('.slick-initialized').slick({
					slidesToShow: 5,
					slidesToScroll: 1,
					arrows: true,
					infinite: true,
					variableWidth: true,
					centerMode: false,
					speed: 300,
					cssEase: 'ease',
					prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-disabled="false" style="display: inline;"><g transform="translate(0 24) rotate(-90)"><rect width="24" height="24" fill="#14181e" opacity="0"></rect><g transform="translate(5 8)"><path d="M7,0a1,1,0,0,0-.707.293l-6,6A1,1,0,0,0,1.707,7.707L7,2.414l5.293,5.293a1,1,0,1,0,1.414-1.414l-6-6A1,1,0,0,0,7,0Z" fill="#14181e"></path></g></g></svg>',
					nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-disabled="false" style="display: inline;"><g transform="translate(0 24) rotate(-90)"><rect width="24" height="24" fill="#14181e" opacity="0"></rect><g transform="translate(5 8)"><path d="M12,16a1,1,0,0,1-.707-.293l-6-6A1,1,0,1,1,6.707,8.293L12,13.586l5.293-5.293a1,1,0,0,1,1.414,1.414l-6,6A1,1,0,0,1,12,16Z" transform="translate(-5 -8)" fill="#14181e"></path></g></g></svg>',
					touchThreshold: 100,
					responsive: [
						{
							breakpoint: 1680,
							settings: {
								slidesToShow: 4,
							},
						},
						{
							breakpoint: 1520,
							settings: {
								slidesToShow: 3,
							},
						},
						{
							breakpoint: 1030,
							settings: {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: 800,
							settings: {
								slidesToShow: 1,
							},
						}],
				})
			}, 500);
		});

		$('.coloris').not('.slick-initialized').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: true,
			infinite: true,
			variableWidth: true,
			centerMode: false,
			speed: 300,
			cssEase: 'ease',
			prevArrow: '<svg class="slick-prev" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-disabled="false" style="display: inline;"><g transform="translate(0 24) rotate(-90)"><rect width="24" height="24" fill="#14181e" opacity="0"></rect><g transform="translate(5 8)"><path d="M7,0a1,1,0,0,0-.707.293l-6,6A1,1,0,0,0,1.707,7.707L7,2.414l5.293,5.293a1,1,0,1,0,1.414-1.414l-6-6A1,1,0,0,0,7,0Z" fill="#14181e"></path></g></g></svg>',
			nextArrow: '<svg class="slick-next" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-disabled="false" style="display: inline;"><g transform="translate(0 24) rotate(-90)"><rect width="24" height="24" fill="#14181e" opacity="0"></rect><g transform="translate(5 8)"><path d="M12,16a1,1,0,0,1-.707-.293l-6-6A1,1,0,1,1,6.707,8.293L12,13.586l5.293-5.293a1,1,0,0,1,1.414,1.414l-6,6A1,1,0,0,1,12,16Z" transform="translate(-5 -8)" fill="#14181e"></path></g></g></svg>',
			touchThreshold: 100,
			responsive: [
				{
					breakpoint: 1680,
					settings: {
						slidesToShow: 4,
					},
				},
				{
					breakpoint: 1520,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 1030,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 800,
					settings: {
						slidesToShow: 1,
					},
				}],
		})

		$('.slick-width').on('click', function () {
			setTimeout(function () {
				$('.coloris').not('.slick-initialized').slick('setPosition')
			}, 100)
		})


		// Concept
		var swiperConcept = new Swiper('.concept-container', {
			direction: 'horizontal',
			loop: false,
			spaceBetween: 16,
			threshold: 20,

			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},

			breakpoints: {
				// when window width is >= 320px
				320: {
					slidesPerView: 3,
					spaceBetween: 20
				},
				// when window width is >= 480px
				768: {
					slidesPerView: 5,
					spaceBetween: 30
				},
				// when window width is >= 640px
				1200: {
					slidesPerView: 6,
					spaceBetween: 40
				}
			},

			on: {
				init: function () {
					setTimeout(function () {

						for (var i = 0; i < swiperConcept.slides.length; i++) {
							var currentPageIndex = 0;

							if (swiperConcept.slides[i].classList.contains("current-page")) {
								swiperConcept.slideTo(i);
							}
						}

						swiperConcept.slides.on('click', function () {
							swiperConcept.slideTo(swiperConcept.clickedIndex);
						});

					}, 2000);
				},
			},
		});


	},
}


// WEBPACK FOOTER //
// ./scripts/routes/singleTravaux.js


// WEBPACK FOOTER //
// ./scripts/routes/singleTravaux.js